/*
 * ========================================
 * Custom Image Fade In
 * ========================================
 */

(() => {
  const fadeInObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add("is-visible");

        fadeInObserver.unobserve(entry.target);
      });
    },
    {
      threshold: 0.1
    }
  );

  const initCustomImageFadeIn = () => {
    const items = document.querySelectorAll(
      ".image-text-pair__item:not(.fade-init)"
    );

    items.forEach((item) => {
      item.classList.add("fade-init");
      fadeInObserver.observe(item);
    });
  };

  initCustomImageFadeIn();

  document.addEventListener(
    "shopify:section:load",
    initCustomImageFadeIn
  );
})();